import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f54bf69e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "small-card__title m-font-size" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "small-card__description" }, " Sed ut perspiciatis, unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam Sed ut perspiciatis, unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam Sed ut perspiciatis, unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam ", -1))
const _hoisted_3 = { class: "center small-card__btn-link" }

import { ResultCardType } from '@/types';
import { useAppStore } from '@/store/modules/app';


export default /*#__PURE__*/_defineComponent({
  __name: 'ResidentialComplexSmallCard',
  props: {
    offerCard: {},
    residentialComplex: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  const _component_base_image = _resolveComponent("base-image")!
  const _component_base_progress_bar = _resolveComponent("base-progress-bar")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_base_divider = _resolveComponent("base-divider")!
  const _component_base_card = _resolveComponent("base-card")!

  return (_openBlock(), _createBlock(_component_base_card, {
    class: "small-card",
    "full-width-mobile": "",
    "without-mobile-shadow": ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_base_image, {
        src: 
        Array.isArray(_ctx.residentialComplex.logo)
          ? _ctx.residentialComplex.logo[0]
          : _ctx.residentialComplex.logo
      ,
        class: "small-card__img",
        contain: "",
        height: "65",
        name: "seller",
        version: "v3",
        width: "95"
      }, null, 8, ["src"]),
      _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.residentialComplex.title), 1),
      _createVNode(_component_base_progress_bar, {
        "max-rate": _ctx.offerCard.classifier?.maxRate,
        rating: _ctx.offerCard.rating,
        class: "small-card__rating"
      }, null, 8, ["max-rate", "rating"]),
      _createVNode(_component_router_link, {
        to: {
        name: 'classification',
        query: { id: _ctx.offerCard.aboutResidentialComplex?.id },
      },
        class: "small-card__btn-more center"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_base_button, {
            "all-block-width": _unref(useAppStore)().getWindowWidth() <= 600,
            height: "36",
            text: "Подробнее",
            width: "118"
          }, null, 8, ["all-block-width"])
        ]),
        _: 1
      }, 8, ["to"]),
      _createVNode(_component_base_divider, { class: "small-card__divider" }),
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_base_button, {
          "all-block-width": _unref(useAppStore)().getWindowWidth() <= 600,
          href: {
          name: 'residentialComplex',
          params: { url: _ctx.residentialComplex.url },
        },
          height: "36",
          "style-type": "coloredBorder",
          text: "На страницу ЖК",
          width: "186"
        }, null, 8, ["all-block-width", "href"])
      ])
    ]),
    _: 1
  }))
}
}

})